import { DefaultMapping } from "_P/copyobj";
import { Store } from "vuex";
import { InsuranceCard } from '@/services/index.defs';

export class RecentCardsHelper {

    static isLocalStorageAccessible() {
        try {
            window?.localStorage?.accessTestAttempt
        }
        catch (e) { console.log(e); return false }
        if (window?.localStorage === null) return false;
        return true;
    }

    static createCardName(store: Store<any>, card: InsuranceCard) {
        if (!this.isLocalStorageAccessible() || !card) return "";
        const dict = store.direct.state.dicti;
        const mark = dict.mapMarks?.find?.(x => x.id == card.car.markId)?.title;
        const model = dict.mapModels?.find?.(x => x.id == card.car.modelId)?.title;
        return `${mark} ${model}`
    }

    static getCards(): RecentCard[] {
        if (!this.isLocalStorageAccessible()) return [];
        if (!localStorage.ppdRecentCards) return [];
        return DefaultMapping(JSON.parse(localStorage.ppdRecentCards)) as RecentCard[];
    }

    static getCard(name: string) {
        return this.getCards().find(x => x.name == name);
    }

    static rememberCard(card: InsuranceCard, name: string) {
        if (!this.isLocalStorageAccessible()) return;
        const list = this.getCards();
        const prev = list.find(x => x.name == name);
        if (!!prev) {
            prev.card = card;
            list.splice(list.findIndex(x => x.name == name), 1, prev);
        }
        else list.push({ card: card, name: name });
        localStorage.ppdRecentCards = JSON.stringify(list);
    }

    static clear() {
        if (!this.isLocalStorageAccessible()) return;
        localStorage.ppdRecentCards = "";
    }

}

export class RecentCard {
    name: string = "";
    card: InsuranceCard = null;
}